import { Card } from "@/components/ui/card";
import { Reveal } from "@/components/Reveal";
import { SmartImage } from "@/components/SmartImage";
import { getIcon } from "@/data/site";

export const TrustSection = ({ about = {} }) => {
  const items = about.items || [];
  const hasImage = Boolean(about.image);
  return (
    <section id="about" className="scroll-anchor bg-background">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        {hasImage ? (
          <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
            <Reveal>
              <div className="max-w-xl">
                <p className="text-sm font-semibold uppercase tracking-wider text-accent">{about.eyebrow}</p>
                <h2 className="font-display mt-2 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
                  {about.heading}
                </h2>
                <p className="mt-4 text-base leading-relaxed text-muted-foreground">{about.body}</p>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="overflow-hidden rounded-2xl border border-border bg-muted shadow-[0_18px_50px_-26px_rgba(15,23,42,0.4)]">
                <div className="aspect-[4/3]">
                  <SmartImage src={about.image} alt="Ecentra products" fallbackLabel="Ecentra" />
                </div>
              </div>
            </Reveal>
          </div>
        ) : (
          <Reveal>
            <div className="max-w-2xl">
              <p className="text-sm font-semibold uppercase tracking-wider text-accent">{about.eyebrow}</p>
              <h2 className="font-display mt-2 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
                {about.heading}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-muted-foreground">{about.body}</p>
            </div>
          </Reveal>
        )}

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((item, i) => {
            const Icon = getIcon(item.icon);
            return (
              <Reveal key={i} delay={i * 0.06}>
                <Card className="h-full rounded-xl border-border bg-card p-6 shadow-[0_10px_30px_-18px_rgba(15,23,42,0.25)] transition-shadow duration-200 hover:shadow-[0_18px_50px_-26px_rgba(15,23,42,0.35)]">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary text-primary">
                    <Icon className="h-6 w-6" />
                  </span>
                  <h3 className="mt-4 text-lg font-semibold text-foreground">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.desc}</p>
                </Card>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
